var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6203_9077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3854 5.14964C18.3752 4.60966 18.3654 4.09956 18.3654 3.60607C18.3654 3.21945 18.052 2.90602 17.6653 2.90602C14.6714 2.90602 12.392 2.04561 10.492 0.19822C10.2201 -0.0661198 9.78761 -0.0660265 9.51589 0.19822C7.61605 2.04561 5.33696 2.90602 2.34326 2.90602C1.95664 2.90602 1.64321 3.21945 1.64321 3.60607C1.64321 4.09965 1.6335 4.60994 1.62314 5.15001C1.52719 10.1751 1.39576 17.0571 9.77463 19.9614C9.84893 19.9872 9.9264 20.0001 10.0039 20.0001C10.0813 20.0001 10.1589 19.9872 10.2331 19.9614C18.6126 17.057 18.4814 10.1748 18.3854 5.14964ZM10.004 18.5571C2.81799 15.9467 2.92664 10.2282 3.02306 5.1767C3.02884 4.87354 3.03444 4.5797 3.03836 4.29165C5.8423 4.1733 8.08452 3.32362 10.004 1.65153C11.9236 3.32362 14.1662 4.17339 16.9703 4.29165C16.9742 4.57961 16.9798 4.87326 16.9856 5.17624C17.082 10.2279 17.1905 15.9466 10.004 18.5571Z",
    fill: "#032279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 7.56828L9.03527 10.9469L7.59345 9.50509C7.32005 9.23179 6.87678 9.23179 6.60348 9.50509C6.33009 9.77858 6.33009 10.2218 6.60348 10.4951L8.54029 12.432C8.67694 12.5686 8.85615 12.6369 9.03527 12.6369C9.21439 12.6369 9.39361 12.5686 9.53026 12.432L13.404 8.55834C13.6775 8.28495 13.6775 7.84167 13.4041 7.56837C13.1308 7.29498 12.6875 7.29489 12.4141 7.56828Z",
    fill: "#032279"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6203_9077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon1);
export default __webpack_public_path__ + "static/media/footer_icon1.4d54250b665ea4cdf04669261c374b7e.svg";
export { ForwardRef as ReactComponent };